/* Wallstraight — casual save friction on opted-in AI preview zones (not DRM).
 * Document capture survives cart drawer panel replaceWith (ws-cart-drawer.js).
 * Firefox Shift+right-click may bypass contextmenu (MDN). */
(function(){
  'use strict';
  if(typeof window==='undefined'||typeof document==='undefined')return;

  var ROOT_SEL='[data-ws-protected-preview]';
  var IGNORE_SEL='a[href],button,.res-retry-btn,[data-ws-preview-protect-ignore]';

  function shouldStop(e){
    if(!e||!e.target||!e.target.closest)return false;
    if(!e.target.closest(ROOT_SEL))return false;
    if(e.target.closest(IGNORE_SEL))return false;
    return true;
  }

  function stopChillSave(e){
    if(!shouldStop(e))return;
    e.preventDefault();
  }

  function markImgs(root){
    if(!root||!root.querySelectorAll)return;
    var imgs=root.querySelectorAll(ROOT_SEL+' img');
    for(var i=0;i<imgs.length;i++)imgs[i].setAttribute('draggable','false');
  }

  function wsPreviewProtectInit(){
    if(document.documentElement.dataset.wsPreviewProtect==='1'){
      markImgs(document);
      return;
    }
    document.documentElement.dataset.wsPreviewProtect='1';
    document.addEventListener('contextmenu',stopChillSave,true);
    document.addEventListener('dragstart',stopChillSave,true);
    markImgs(document);
    if(typeof MutationObserver!=='function')return;
    new MutationObserver(function(muts){
      for(var m=0;m<muts.length;m++){
        var nodes=muts[m].addedNodes;
        for(var n=0;n<nodes.length;n++){
          if(nodes[n].nodeType===1)markImgs(nodes[n]);
        }
      }
    }).observe(document.body,{childList:true,subtree:true});
  }

  window.wsPreviewProtectInit=wsPreviewProtectInit;

  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',wsPreviewProtectInit,{once:true});
  }else{
    wsPreviewProtectInit();
  }
})();
